export const blockCodeToolbox = {
  kind: 'categoryToolbox',
  contents: [
    {
      kind: 'category',
      name: 'Lógica',
      categoryId: 'logic',
      contents: [
        {
          kind: 'block',
          type: 'controls_if',
        },
        {
          kind: 'block',
          type: 'logic_compare',
        },
        {
          kind: 'block',
          type: 'logic_negate',
        },
        {
          kind: 'block',
          type: 'logic_operation',
        },
        {
          kind: 'block',
          type: 'logic_boolean',
        },
      ],
    },
    {
      kind: 'category',
      categoryId: 'loops',
      name: 'Loops',
      contents: [
        {
          kind: 'block',
          type: 'controls_repeat_ext',
          inputs: {
            TIMES: {
              shadow: {
                type: 'math_number',
                id: 'y9E0ncsHoJ2TzCGiM@MJ',
                fields: {
                  NUM: 5,
                },
              },
            },
          },
        },
        {
          kind: 'block',
          type: 'controls_whileUntil',
          fields: {
            MODE: 'WHILE',
          },
        },
      ],
    },
    {
      kind: 'category',
      categoryId: 'text',
      name: 'Texto',
      contents: [
        {
          kind: 'block',
          type: 'text',
          fields: {
            TEXT: 'seu texto',
          },
        },
        {
          kind: 'block',
          type: 'text_print',
          inputs: {
            TEXT: {
              shadow: {
                type: 'text',
                fields: {
                  TEXT: 'abc',
                },
              },
            },
          },
        },
      ],
    },
    {
      kind: 'category',
      name: 'Variáveis',
      custom: 'VARIABLE_DYNAMIC',
      contents: [
        {
          kind: 'block',
          type: 'variables_set',
        },
        {
          kind: 'block',
          type: 'variables_get',
        },
      ],
    },
    {
      kind: 'category',
      categoryId: 'math',
      name: 'Matemática',
      contents: [
        {
          kind: 'block',
          type: 'math_number',
        },
        {
          kind: 'block',
          type: 'math_arithmetic',
          inputs: {
            A: {
              shadow: {
                type: 'math_number',
                id: '{BcweU3RGETzFcj#.vBC',
                fields: {
                  NUM: 1,
                },
              },
            },
            B: {
              shadow: {
                type: 'math_number',
                id: '3M!|q=WPSZ%!|,:(WRPm',
                fields: {
                  NUM: 1,
                },
              },
            },
          },
        },
        {
          kind: 'block',
          type: 'math_single',
          fields: {
            OP: 'ROOT',
          },
          inputs: {
            NUM: {
              shadow: {
                type: 'math_number',
                fields: {
                  NUM: 4,
                },
              },
            },
          },
        },
      ],
    },
  ],
};
